var map = {
	"./adult/nn/1 0 Orddiktat Intro.mp3": 702,
	"./adult/no/1 0 Orddiktat Intro.mp3": 703,
	"./adult/se/1 0 Orddiktat Intro.mp3": 704,
	"./youth/de/1 0 Orddiktat Intro.mp3": 705,
	"./youth/nn/1 0 Orddiktat Intro.mp3": 706,
	"./youth/no/1 0 Orddiktat Intro.mp3": 707,
	"./youth/se/1 0 Orddiktat Intro.mp3": 708
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 701;